import { holdsActiveTransitionTargetData } from '../../../functions/client-model/client-node/holds-active-transition-target-data';
import { ClientNode } from '../../../model/client-model/client-node';
import { ClientBoardContainer } from '../../../public/dashboard/shared/model/client-board-container';

export function getTransitionTargets(board: ClientBoardContainer): ClientNode[] {
  const nodes = Object.values(board.nodes);

  return nodes.filter(holdsActiveTransitionTargetData);
}
